import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "@/components/specific/Breadcrumb";
import Button from "@/components/common/Button";
import AccountFAQ from "@/pages/settings/components/FAQ/Account_FAQ";
import CampaignFAQ from "@/pages/settings/components/FAQ/Campaign_FAQ";
import CorporateManagementFAQ from "@/pages/settings/components/FAQ/Corporate_FAQ";

function Faq() {
  const [activeTab, setActiveTab] = useState("account"); // 'account', 'campaign', or 'corporate'
  const navigate = useNavigate();

  // Add refs for child components
  const accountRef = useRef();
  const campaignRef = useRef();
  const corporateRef = useRef();

  // Define breadcrumb items for FAQ
  const breadcrumbItems = [
    // { title: 'Settings', path: '/settings' },
    // { title: 'Help', path: '/settings/help' },
    { title: "Help and FAQ", path: "/settings/help/faq" },
  ];

  const handleContactSupport = () => {
    navigate("/dashboard/settings/support");
  };

  return (
    <div className="text-left">
      <div className="mb-3 mt-10">
        <Breadcrumb items={breadcrumbItems} />
      </div>

      <h1 className="mb-2 heading-large text-black">GENERAL HELP AND FAQ</h1>

      <div className="flex items-center justify-between">
        <div className="flex gap-2 overflow-x-auto pb-2 hide-scrollbar sm:max-w-[80vw] md:max-w-none">
          <Button
            text="Account"
            customBgColor={activeTab === "account" ? "primary" : "white"}
            customTextColor={activeTab === "account" ? "white" : "primary"}
            className="w-[140px] h-[37px] text-xs border border-primary whitespace-nowrap"
            onClick={() => setActiveTab("account")}
          />
          <Button
            text="Campaign"
            customBgColor={activeTab === "campaign" ? "primary" : "white"}
            customTextColor={activeTab === "campaign" ? "white" : "primary"}
            className="w-[140px] h-[37px] text-xs whitespace-nowrap border border-primary"
            onClick={() => setActiveTab("campaign")}
          />
          <Button
            text="Corporate Management"
            customBgColor={activeTab === "corporate" ? "primary" : "white"}
            customTextColor={activeTab === "corporate" ? "white" : "primary"}
            className="w-[180px] h-[37px] text-xs whitespace-nowrap border border-primary"
            onClick={() => setActiveTab("corporate")}
          />
        </div>
        <Button
          text="Contact Support"
          customTextColor="white"
          customBgColor="primary"
          className="w-[140px] h-[37px] text-xs hidden lg:flex"
          onClick={handleContactSupport}
        />
      </div>

      {activeTab === "account" && <AccountFAQ ref={accountRef} />}
      {activeTab === "campaign" && <CampaignFAQ ref={campaignRef} />}
      {activeTab === "corporate" && (
        <CorporateManagementFAQ ref={corporateRef} />
      )}

      {/* Mobile Contact Support Button */}
      <Button
        text="Contact Support"
        customTextColor="white"
        customBgColor="primary"
        className="w-full text-xs lg:hidden mt-6"
        onClick={handleContactSupport}
      />
    </div>
  );
}

export default Faq;
